import { Component } from '@angular/core';
import { Location } from '@angular/common';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss']
})

export class NotFoundComponent {   
    public copyrightYear: number;
   
    constructor(
        private _location: Location
    ) {

        this.copyrightYear = new Date().getFullYear();
    }

    public navigateBack(): void {
        this._location.back();
    }
}